<template>
  <span>{{ money }}</span>
</template>

<script>
import Vue from "vue";
import { formatM } from "@/lib/utils/accountingJsFns";

export default Vue.extend({
  name: "MoneyMontoComponent",
  computed: {
    money() {
      return formatM(this.params.data.Monto);
    },
  },
});
</script>

<style scoped></style>
